import { useEffect, useState } from 'react';
import {useSelector } from 'react-redux';
import { Helmet } from 'react-helmet';
import { toast } from 'react-toastify';
import moment from 'moment';
import Loader from '../../../../components/ui/Loader/Loader';
import TapIcon from '../../../../services/TapIcon';
import { apiRunWithAxios } from './APIRunWithAxios';


const DeviceHistory = (props) => {
    const [loading, setLoading]         =   useState(false);
    const [deviceData, setDeviceData]   =   useState(null);

    const access_token                  =   useSelector(state => state.auth.access_token);

   useEffect(() => {
    if (props.formData?.imeis?.length) {
        fetchDeviceData(
            props.formData.imeis,
            props.formData.date_range_start,
            props.formData.date_range_end
        );
       }
   }, [props.formData]);

    const fetchDeviceData = async (imeis, startDate, endDate) => {

        setLoading(true);
        setDeviceData(null);

        try {
            const requestBody = {
                imeIs: imeis,
                startDate : new Date(startDate).toISOString(),
                endDate :new Date(endDate).toISOString()
            };

            let response = await apiRunWithAxios("https://api6.tappetbox.in/api/DeviceData/get-historical", "POST", access_token, {}, requestBody);

            setDeviceData(response.data)
            
        } catch (error) {
            toast.error('Failed to fetch device data', { position: toast.POSITION.TOP_RIGHT });
        } finally {
            setLoading(false);
        }
    };

    const handleLocationClick = (latitude, longitude) => {
        if (!latitude || !longitude || isNaN(parseFloat(latitude)) || isNaN(parseFloat(longitude))) {
            toast.error('Invalid location coordinates', { position: toast.POSITION.TOP_RIGHT });
            return;
        }

        const mapsUrl = `https://www.google.com/maps?q=${latitude},${longitude}`;
        window.open(mapsUrl, '_blank', 'noopener,noreferrer');
    };

    const formatValue = (key, value, record = null) => {
        if (value === null || value === undefined) return 'N/A';

        if (typeof value === 'boolean') {
            return value ? 'Yes' : 'No';
        }

        if (typeof value === 'number') {
            switch (key) {
                case 'speed':
                    return `${value} km/h`;
                case 'direction':
                    return `${value}°`;
                case 'altitude':
                    return `${value} m`;
                case 'externalVoltage':
                case 'batteryVoltage':
                    return `${value} V`;
                default:
                    return value.toString();
            }
        }


        if ((key.toLowerCase().includes('time') || key.toLowerCase().includes('date')) && !isNaN(Date.parse(value))) {
            return moment(value).format('DD-MMM-YYYY HH:mm:ss');
        }

        if (key.toLowerCase().includes('imei') && record) {
            const hasValidLocation = record.latitude && record.longitude &&
                !isNaN(parseFloat(record.latitude)) && !isNaN(parseFloat(record.longitude));

            if (hasValidLocation) {
                return (
                    <button
                        className="btn btn-link p-0 text-primary text-decoration-none"
                        onClick={() => handleLocationClick(
                            record.latitude,
                            record.longitude,
                        )}
                    >
                        {value}
                    </button>
                );
            }
        }

        return value.toString();
    };

    const renderDeviceData = () => {
        const dataToUse             =   deviceData;

        if (!dataToUse) return null;

       
   const excludedKeys = ['deviceAsset', 'extra'];

const filterKeys = (obj) => {
    return Object.fromEntries(
        Object.entries(obj).filter(([key]) => !excludedKeys.includes(key))
    );
};

        if (Array.isArray(dataToUse)) {
            if (dataToUse.length === 0) {
                return (
                    <div className="row mt-4">
                        <div className="col-12 text-center">
                            <h6> No data found for the selected criteria.</h6>
                        </div>
                    </div>
                );
            }

           const filteredFirstRecord = {
            ...filterKeys(dataToUse[0]),
            fuelVoltage: dataToUse[0]?.extra?.fuelVoltage ?? 'N/A',
            fuelLiters: dataToUse[0]?.extra?.fuelLiters ?? 'N/A',
        };
            return (
                <div className="row mb-4">
                    <div className="col-12">
                        <div className="d-flex justify-content-between align-items-center mb-3">
                            <h5 className="card-title mb-0">
                                Asset History Data
                            </h5>
                        </div>

                        <div className="card">
                            <div className="card-body p-0">
                                <div className="table-responsive" style={{
                                    scrollbarWidth: 'thin',
                                    maxHeight: "calc(100vh - 200px)",
                                    overflowY: 'auto',
                                    overflowX: 'auto'
                                }}>
                                    <table className="table table-hover table-bordered table-fixed">
                                        <thead className="table-secondary" style={{
                                            position: 'sticky',
                                            top: 0,
                                            zIndex: 1,
                                            backgroundColor: '#f8f9fa'
                                        }}>
                                            <tr>
                                                {Object.keys(filteredFirstRecord).map((key) => (
                                                    <th key={key} className="text-nowrap text-center">
                                                        {key}
                                                    </th>
                                                ))}
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {dataToUse.map((record, index) => {
                                                const filteredRecord = {
                                                    ...filterKeys(record),
                                                    fuelVoltage: record?.extra?.fuelVoltage ?? 'N/A',
                                                    fuelLiters: record?.extra?.fuelLiters ?? 'N/A',
                                                };
                                                return (
                                                    <tr key={index}>
                                                        {Object.entries(filteredRecord).map(([key, value]) => (
                                                            <td key={key} className="text-nowrap text-center">
                                                                {formatValue(key, value, record)}
                                                            </td>
                                                        ))}
                                                    </tr>
                                                );
                                            })}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            );
        }

        const filteredData = filterKeys(dataToUse);

        return (
            <div className="row mt-4">
                <div className="col-sm-9">
                    <div className="card">
                        <div className="card-header">
                            <h5 className="card-title mb-0">Response</h5>
                        </div>
                        <table className="table table-hover table-borderless">
                            <tbody>
                                {Object.entries(filteredData).map(([key, value]) => (
                                    <tr key={key}>
                                        <td className="details-label" style={{ "width": "34%" }}>{key}</td>
                                        <td className="details-name" style={{ "width": "66%" }}>{formatValue(key, value, dataToUse)}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        );
    };

    return (
        <>
            <Helmet><title>Device History</title></Helmet>
            <div className="bg-white px-2">
                {loading && <Loader />}
                {renderDeviceData()}
            </div>

        </>
    );
};

export default DeviceHistory;